// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--bNHdp","editable":"editable--vY6XS"};